import Navbar from "../Components/Navbar";
// import ExploreBanner from "../Components/ExploreBanner";
import Places from "../Components/Places";
import Footer from "../Components/Footer";

function Explore() {
  return (
    <>
      <Navbar />
      {/* <ExploreBanner /> */}
      <Places />
      <Footer />
    </>
  );
}

export default Explore;